import actions from 'redux/actions'
import { getState } from 'redux/core'
import { constants, getPrefixedAddressFields, mixpanel, links } from 'common/helpers'
import { setupBegin, setupCommit, setupBeginPayPal, setupCommitPayPal, callVindicia,
  syncUserAndSubscription, callAnalytics } from './util'


const begin = (values) => {
  const {
    models: {
      me: { gender: myGender, email: myEmail },
      requestTokens: { giftCard: giftCardToken },
    },
  } = getState()
  const { paymentMethod, ...restValues } = values

  const body = {
    email: myEmail, // TODO @backend do we need this?
    gender: myGender, // TODO @backend do we need this?
    senderEmail: myEmail, // TODO @backend do we need this?
    paymentType: paymentMethod, // TODO ask backend rename `paymentType` to `paymentMethod`
    token: giftCardToken,
    ...restValues,
  }

  const begin = setupBegin({
    endpoint: 'rest/gift/card/begin',
    tokenName: constants.requestTokens.giftCard,
  })

  return begin(body)
}

/**
 *
 * @param {number} giftCardSession
 * @param {string} token
 */
const commit = setupCommit({
  endpoint: 'rest/gift/card/commit',
  tokenName: constants.requestTokens.giftCard,
})

/**
 *
 * @param {object} values
 * @param {object} values.giftCard
 * @param {number} values.giftCard.id
 * @param {number} values.giftCard.amount
 * @param {string} values.giftCard.sendBy
 * @param {string} values.giftCard.sendToDate
 * @param {string} values.giftCard.gender
 * @param {string} values.giftCard.email
 * @param {string} values.giftCard.name
 * @param {string} values.giftCard.message
 * @param {object} values.shipping
 * @param {object} values.billing
 * @param {object} values.creditCard
 * @param {string} values.paymentType
 * @param {string} values.paymentMethod
 * @returns {*}
 */
const _buyGiftCard = (values) => {
  const { beginBody, giftCard, shipping, billing, creditCard, paymentType } = values

  mixpanel.track(constants.analyticsEvents.tech.buyGiftCard)

  return begin(beginBody)
    .then(
      ({ giftCardSession, ...data }) => (
        callVindicia({
          paymentType,
          shipping,
          billing,
          creditCard,
          giftCard,
          giftCardSession,
          ...data,
        })
          .then(() => {
            const { models: { requestTokens: { giftCard: giftCardToken } } } = getState()

            return commit({
              giftCardSession,
              token: giftCardToken,
            })
          })
      ),
      (err) => Promise.reject(err)
    )
    .then(
      (result) => syncUserAndSubscription({ paymentType, ...result }),
      (err) => {
        const { title, message, resData: { isCvvError, authCode } } = err

        const isBillingError = authCode === '713'

        actions.view.paymentPage.setBillingError(isBillingError)

        if (isCvvError) {
          actions.models.modals.open(constants.modals.ErrorCVV)
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            title,
            content: message,
          })
        }

        return Promise.reject(err)
      }
    )
    .then(() => {
      actions.view.paymentPage.setBillingError(false)
      callAnalytics()
      actions.models.router.push(links.thankYou)
    })
}

const getDigitalGiftCardValues = (values) => {
  const { billing, giftCard, paymentMethod } = values
  const { id, type, amount, sendToDate, recipientGender, recipientEmail, recipientName, personalMessage } = giftCard

  const _values = {
    ...values,
    beginBody: {
      paymentMethod,
      ...getPrefixedAddressFields({ billing }),
      cardType: type,
      cardStyle: id,
      giftGender: recipientGender, // TODO @backend do we need this?
      recipientName,
      recipientEmail,
      personalMessage,
      amount,
    },
  }

  if (sendToDate) {
    _values.beginBody.sendEmailDate = sendToDate
  }

  return _values
}

const getPhysicalGiftCardValues = (values) => {
  const { giftCard, shipping, billing, paymentMethod } = values
  const { id, type, amount, recipientGender } = giftCard

  return {
    ...values,
    beginBody: {
      paymentMethod,
      ...getPrefixedAddressFields({ shipping, billing }),
      cardType: type,
      cardStyle: id,
      giftGender: recipientGender, // TODO @backend do we need this?
      amount,
    },
  }
}

/**
 *
 * @param {object} values
 * @param {object} values.billing
 * @param {object} values.creditCard
 * @param {object} values.giftCard
 * @param {string} values.paymentType
 * @param {string} values.paymentMethod
 * @returns {*}
 */
const buyGiftCard = (values) => {
  const { giftCard: { type } } = values
  let _values

  if (type === 'Digital') {
    _values = getDigitalGiftCardValues(values)
  }
  else {
    _values = getPhysicalGiftCardValues(values)
  }

  return _buyGiftCard(_values)
}


// PayPal

/**
 *
 * @param {object} values
 * @param {object} values.billing
 * @param {object} values.creditCard
 * @param {object} values.giftCard
 * @param {string} values.paymentType
 * @param {string} values.paymentMethod
 * @returns {*}
 */
const beginGiftCardUsingPayPal = (values) => {
  const beginPayPal = setupBeginPayPal({
    begin,
    sessionName: 'giftCardSession',
  })

  const { giftCard: { type } } = values
  let _values

  if (type === 'Digital') {
    _values = getDigitalGiftCardValues(values)
  }
  else {
    _values = getPhysicalGiftCardValues(values)
  }

  return beginPayPal(_values.beginBody)
}

/**
 *
 * @param values
 * @param {string} values.paymentType
 * @param {string} values.paypalSessionId
 */
const commitGiftCardUsingPayPal = (values) => {
  const commitPayPal = setupCommitPayPal({
    commit,
    sessionName: 'giftCardSession',
  })

  return commitPayPal(values)
}


export {
  buyGiftCard,
  beginGiftCardUsingPayPal,
  commitGiftCardUsingPayPal,
}
